import { Table, TableBody, TableCell, TableHead, TableRow } from '@trackman/web-shared-components';
import { Input } from '@trackman/web-shared-components';
import { ClubKey, clubs, TourAveragesParameter } from 'types/admin/tourAverages';
import { ReactComponent as TrashIcon } from 'images/icons/Trash.svg';
import { unitNamesMapper } from 'utilities/unitNamesMapper';

type Props = {
  kind: 'PGA' | 'LPGA';
  tourAveragesScoresArray: TourAveragesParameter[];
  handleDeleteColumn: (index: number) => void;
  onScoreChange: (columnIndex: number, club: ClubKey, value: string) => void;
};

export const TourAveragesTable = ({ kind, tourAveragesScoresArray, handleDeleteColumn, onScoreChange }: Props) => {
  return (
    <div className='tmu-table-wrapper pga-table'>
      <div className='table-header'>
        <div className='table-title'>
          <h2>{kind} TOUR DATA</h2>
        </div>
      </div>
      <Table className='tmu-table admin-table'>
        <TableHead>
          <TableRow>
            <TableCell width='200px'> </TableCell>
            {tourAveragesScoresArray.map((parameterData, index) => {
              return (
                <TableCell key={parameterData.parameterId} width='200px'>
                  <div className='column-data-wrapper'>
                    <div className='parameter-info'>
                      <div className='parameter-name'>{parameterData.parameterName ?? ''}</div>
                      {parameterData.unit ? <div className='parameter-unit'>({unitNamesMapper(parameterData.unit)})</div> : null}
                    </div>
                    <button className='delete-button' onClick={() => handleDeleteColumn(index)}>
                      <TrashIcon />
                    </button>
                  </div>
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {tourAveragesScoresArray.length ? (
            clubs.map(({ key: club, name }) => (
              <TableRow hover tabIndex={-1} key={club}>
                <TableCell width='200px'>{name}</TableCell>
                {tourAveragesScoresArray.map((parameterData, colIndex) => {
                  return (
                    <TableCell key={parameterData.parameterId} width='200px'>
                      <Input
                        type='text'
                        label=''
                        value={tourAveragesScoresArray[colIndex]?.clubs[club] ?? ''}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          const value = e.currentTarget.value.replace(',', '.').replace(/[^0-9.-]/g, '');
                          onScoreChange(colIndex, club, value);
                        }}
                      />
                    </TableCell>
                  );
                })}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell>No data to show</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default TourAveragesTable;
